var t = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImF6ZXJzdW4iLCJuYmYiOjE2OTcwMTk4NjYsImV4cCI6MTcwMzAxOTg2NiwiaWF0IjoxNjk3MDE5ODY2fQ.hU8KMJ9An6PbmChb6L5aCVXQbipm2-cWhH0HEORSE_U';//2023-12-20T00:04:26.7374299+03:00
// Wait for the element with a specific class to become visible
function waitForElementToBeVisible(className, callback) {
  var elements = document.getElementsByClassName(className);
  var observer = new MutationObserver(function (mutations, observer) {
    for (var i = 0; i < elements.length; i++) {
      if (elements[i].offsetParent !== null) {
        observer.disconnect();
        callback(elements[i]);
        break;
      }
    }
  });
  observer.observe(document, { attributes: true, subtree: true });
}

function mobileDevice() {
    var standalone = window.navigator.standalone,
        userAgent = window.navigator.userAgent.toLowerCase(),
        safari = /safari/.test(userAgent),
        ios = /iphone|ipod|ipad/.test(userAgent);

    // Check for iOS devices
    if (ios) {
        // Returns true for iOS webview and false for Safari
        return !standalone && !safari;
    } else {
        // Check for Android devices
        // Returns true for Android webview
        return userAgent.includes('wv');
    }
}

// Scroll to the element
function scrollToElement(element) {
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

// Usage
waitForElementToBeVisible('buunto-error-tooltip', function (element) {
  scrollToElement(element);
});

document.addEventListener('DOMContentLoaded', function() {
  // Get all the add-to-cart buttons
  var addToCartButtons = document.querySelectorAll('.add-to-cart-button');

  // Get the location dropdowns
  var locationDropdown = document.getElementById('location-popup');
  var mobileLocationDropdown = document.getElementById('location-popup-mobile');

  // Add a click event listener to each add-to-cart button
  addToCartButtons.forEach(function(button, index) {
    button.addEventListener('click', function(event) {
      // Get the locationCode from local storage
      var locationCode = localStorage.getItem('locationCode');

      // Check if the locationCode is empty
      if (!locationCode) {
        // Prevent the default form submission
        event.preventDefault();

        // Check if the device is mobile
        if (window.matchMedia('(max-width: 767px)').matches) {
          // Trigger a click event on the mobile location dropdown input
          mobileLocationDropdown.click();
        } else {
          // Trigger a click event on the desktop location dropdown input
          locationDropdown.click();
        }
      }
    });
  });
});

$(function(){
  
  $('.show-only-app').each(function() {
        if (mobileDevice()) {
            $(this).removeClass('hidden');
        } else {
            $(this).addClass('hidden');
        }
    });

    $('.hide-only-app').each(function() {
        if (mobileDevice()) {
            $(this).addClass('hidden');
        } else {
            $(this).removeClass('hidden');
        }
    });

  $('form#create_customer').attr('action', 'javascript:;');
  $('form#create_customer button').click(function(){
    var validation = ValidateForm($(this).parents('form'));
    if(validation){
      if($('.dogrulama').hasClass('hidden'))
        SendSmsCode($('#RegisterForm-phone').val());
      else
        ValidateSmsCode($('#RegisterForm-phone').val(), $('#RegisterForm-phone-code').val());
    }
  });
  
  $(document).on("click", "#custom-close-icon", function () {
    debugger;
    $('#custom-overlay').remove();
  });
  
  $(".menu-drawer-container .icon-close").click(function() {
    $(".menu-drawer-container").removeClass('menu-opening');
    $(".header__icon--menu").attr("aria-expanded","false");
    $(".menu-drawer-container").removeAttr("open");
  });
  
  $("#cart-icon-bubble").click(function() {
    $(".cart-content").addClass('active');
    $(".overlay").addClass('overlay_active');
  });
  
  $('.close-icon, .overlay').click(function() {
    $(".cart-content").removeClass('active');
    $(".overlay").removeClass('overlay_active');
  });

  $(".user-background").click(function() {
    $(".tm_header-dropdown .my-account").slideToggle();
    $('.tm_header-dropdown').toggleClass('active')
  });

  $("#cart-icon-bubble").click(function() { 
    $("#cart_reload").load("#cart_reload .cart_content > *");
  });

  more_nav();
});

function SendSmsCode(phone){
  var settings = {
    "url": "https://azersun.hollyconnect.com/api/otp/MobilePhoneCheck",
    "method": "POST",
    "timeout": 0,
    "async": true,
    "cache": false,
    "headers": {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
      "Content-Type": "application/json",
      "Authorization": "Bearer " + t + ""
    },
    "data": JSON.stringify({
      "language": 0,
      "mobilePhone": phone
    }),
  };
  
  $.ajax(settings).done(function (response) {
    if(response){
        $('.dogrulama').removeClass('hidden');
    }
    else
      customAlert(response.message);
  });
}

function ValidateSmsCode(phone, code){
    var settings = {
    "url": "https://azersun.hollyconnect.com/api/otp/CodeCheck",
    "method": "POST",
    "timeout": 0,
    "headers": {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
      "Content-Type": "application/json",
      "Authorization": "Bearer " + t + ""
    },
    "data": JSON.stringify({
      "language": getLanguageID(Shopify.locale),
      "mobilePhone": phone,
      "code": code
    }),
  };
  
  $.ajax(settings).done(function (response) {
      console.log(response);
      if(response.isSuccess){
        customAlert(response.message);
        $('form#create_customer').attr('action', '/account'); 
        $('form#create_customer').submit();
      }
      else
        customAlert(response.message);
  });
}

function ValidateForm(form) {
  var result = true;
  form.find('.required').each(function(i, v) {
    if ($(v).val() === '' && result) {
      result = false;
      $(v).css('border-bottom', '1px solid #ff0000');
    } else {
      $(v).css('border-bottom', '1px solid #B3B93C');
    }
  });
  return result; // Return the correct result
}

function getLanguageID (language) {
  switch(language) {
    case "az" :
    {
      return 0; break;
    }
    case "tr" :
    {
      return 1; break;
    }
    case "ru" :
    {
      return 2; break;
    }
    case "en" :
    {
      return 3; break;
    }
  }
}

function customAlert(message){
  var overlay = `<div class="overlay" id="custom-overlay">
    <div class="popup" id="custom-alert">
      <span class="close-icon" id="custom-close-icon">&times;</span>
      ` + message + `
    </div>
  </div>`
  $('body').append(overlay);
  $('#custom-alert').css('display', 'block');
  $('#custom-overlay').css('display', 'block');
}

function more_nav() {
  if ($(window).width() >= 1270) {
      var max_elem = 8;
      var items = $('#header-nav > li');
      var surplus = items.slice(max_elem, items.length);
      surplus.wrapAll('<li class="more-site-nav hiden_menu"><div class="site-nav__dropdown"><ul>');
      $('.hiden_menu').prepend('<a class="logo--left__link site-nav__link site-nav__link--main" href="#">more</a>')
  } else {
      var max_elem = 8;
      var items = $('#header-nav > li');
      var surplus = items.slice(max_elem, items.length);
      surplus.wrapAll('<li class="more-site-nav hiden_menu"><div class="site-nav__dropdown"><ul class="list-menu list-menu--disclosure">');
      $('.hiden_menu').prepend('<a class="header__menu-item list-menu__item link" href="#">more</a>')
  }
}
 